// ── TypeScript types matching SharePoint schema ──────────────────────────────

export interface GroundControlLocation {
  id?: string;
  Area: string;
  AreaType: string;
  Schedule?: string;
  Enabled?: boolean;
  LastInspectedDate?: string;
  NumberOfConcerns?: number;
  AllRedTaped?: string;
  InspectedBy?: string;
  GroundMatrixScore?: number;
  NextInspectionDueBy?: string;
  Comment?: string;
}

export interface Inspection {
  id?: string;
  Area: string;
  AreaType: string;
  DateInspected: string;
  InspectedBy: string;
  Supervisor: string;
  RedTaped: string;
  HighbackInspected: string;
  NumberOfConcerns: number;
  Comment?: string;
  Year: number;
  Period: string;
}

export interface Concern {
  id?: string;
  Area: string;
  AreaType: string;
  Deficiency: string;
  RemedialAction: string;
  SpadBT: string;
  Remediated: string;
  RemediatedDate?: string;
  Comment?: string;
  Inspector: string;
  Supervisor: string;
  InspectionDate: string;
  Status: string;
}

export interface DraftInspection {
  localId: string;
  savedAt: string;
  Area: string;
  AreaType: string;
  DateInspected: string;
  InspectedBy: string;
  Supervisor: string;
  RedTaped: string;
  HighbackInspected: string;
  NumberOfConcerns: number;
  Comment?: string;
  Year: number;
  Period: string;
  draftConcerns?: DraftConcern[];
}

export interface DraftConcern {
  localId: string;
  parentDraftId?: string;
  Area: string;
  AreaType: string;
  Deficiency: string;
  RemedialAction: string;
  SpadBT: string;
  Remediated: string;
  RemediatedDate?: string;
  Comment?: string;
  Inspector: string;
  Supervisor: string;
  InspectionDate: string;
  Status: string;
}

// ── Reference data ────────────────────────────────────────────────────────────

export const DEFICIENCY_CHOICES = [
  "Loose rock / scaling required",
  "Inadequate support",
  "Water ingress / seepage",
  "Ground movement observed",
  "Damaged mesh / screen",
  "Missing or inadequate bolts",
  "Cracking / fracturing",
  "Highback deterioration",
  "Rib spalling",
  "Floor heave",
  "Unsupported back span",
  "Shotcrete failure",
];

export const REMEDIAL_ACTION_CHOICES = [
  "Scale and re-support",
  "Install additional rock bolts",
  "Install mesh / screen",
  "Apply shotcrete",
  "Red tape / barricade area",
  "Install drainage / dewater",
  "Engineering assessment required",
  "Grout and re-inspect",
  "Increase inspection frequency",
  "Monitor and report",
];

export const AREA_TYPES = [
  "Underground",
  "Surface",
  "Shaft",
  "Infrastructure",
  "Outdoor",
  "Processing",
];

// ── Filter/sort state ────────────────────────────────────────────────────────

export interface DashboardFilters {
  locationText: string;
  inspectorText: string;
  lastInspectedFrom?: string;
  nextDueBefore?: string;
  areaType: string;
  locationQuick: string;
  sortField: 'LastInspectedDate' | 'NextInspectionDueBy';
  sortDir: 'asc' | 'desc';
}
